import { useState } from "react";
import { ArrowRight, Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { trackCTAClick } from "@/lib/analytics";

const links = [
    { label: "How It Works", href: "#how-it-works", id: "nav-how-it-works" },
    { label: "Outcomes", href: "#outcomes", id: "nav-outcomes" },
    { label: "Pricing", href: "#pricing", id: "nav-pricing" },
];

export const Nav = () => {
    const [open, setOpen] = useState(false);
    return (
        <header
            data-testid="site-nav"
            className="fixed inset-x-0 top-0 z-50 border-b border-gray-100 bg-white/90 backdrop-blur-xl"
        >
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-8">
                <Logo />
                <nav className="hidden items-center gap-8 md:flex">
                    {links.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={l.id}
                            className="text-sm font-medium text-[#4B5563] transition-colors hover:text-[#0B1F44]"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#growth-review"
                        data-testid="nav-cta-button"
                        onClick={() => trackCTAClick("nav")}
                        className="inline-flex items-center gap-2 rounded-full bg-[#2563EB] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700"
                    >
                        Book a Growth Review
                        <ArrowRight className="h-4 w-4" />
                    </a>
                </nav>
                <button
                    data-testid="nav-mobile-toggle"
                    className="md:hidden text-[#0B1F44]"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                </button>
            </div>
            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="border-t border-gray-100 bg-white px-6 py-4 md:hidden"
                >
                    <div className="flex flex-col gap-4">
                        {links.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`${l.id}-mobile`}
                                onClick={() => setOpen(false)}
                                className="text-sm font-medium text-[#4B5563]"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href="#growth-review"
                            data-testid="nav-cta-button-mobile"
                            onClick={() => setOpen(false)}
                            className="inline-flex items-center justify-center gap-2 rounded-full bg-[#2563EB] px-5 py-2.5 text-sm font-semibold text-white"
                        >
                            Book a Growth Review
                            <ArrowRight className="h-4 w-4" />
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};
